import React from 'react';
import {Link} from 'react-router-dom';
import PageHeading from '../components/PageHeading';
import Icon from '../components/Icon';
import {bookList} from '../data/dasgal3/Booklist';
import {useProgress} from '../utils/progress';

export default function BookListPage() {
  const progress = useProgress();
  return <section className="page-shell">
    <PageHeading title="Зургаар бүлэг таах" icon="image"/>
    <div className="list-panel">
      <div className="list-panel__top"><h2>📜 Номоо сонгоно уу!</h2></div>
      <div className="book-grid">{bookList.filter(book => book.key).map((book,index) => <Link to={`/buleg-taah/${book.key}`} key={book.key} className="book-card">
        <span className="book-card__icon"><Icon name="book" size={28}/></span>
        <span className="book-card__index">{String(index+1).padStart(2,'0')}</span>
        <h3>{book.label}</h3>
        <span className="book-card__bottom">{progress[`buleg-taah-${book.key}`] ? <Icon name="check" size={19}/> : <span/>}<Icon name="right" size={19}/></span>
      </Link>)}</div>
    </div>
  </section>;
}
